<!--录入额外积分-->
<template lang="pug">
    el-dialog(title="录入额外积分", width="60%", :visible.sync='visible' :append-to-body="true" @close="closeForm()")
      el-form(:model='dataForm', class='ewjfll' , ref='dataForm', label-suffix=":" label-width="100px" class='chose')
          el-form-item(label="")
              font.font_later 额外积分录入
              el-input-number(v-model="dataForm.rewardPoint"   :min="-99"   style='margin-left:50px;')
          //- el-form-item(label="姓名2得分" prop="scoreMin")
          //-     el-input-number(v-model="dataForm.scoreMin" :min="0" :max="100000000" style='margin-left:50px;')
          //- font.font_later 姓名1让姓名2 0.5分
      span.dialog-footer(slot="footer")
          el-button(type="primary" @click='sure') 确 定
          el-button(@click="closeForm()") 取 消
</template>
<script>
export default {
  name: 'UpdateGrade',
  data () {
    return {
      visible: false,
      dataForm: {
        rewardPoint: '周三'
      },
      rules: []
    }
  },
  methods: {
    sure () {
      this.$http({
        url: this.$http.adornUrl(`/ctCompetition/grade/saveMemberRewardPoints`),
        method: 'post',
        data: this.dataForm
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message.success('操作成功')
          this.$emit('refreshList')
          this.visible = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    init (row, id) {
      console.log(row)
      this.dataForm.memberId = row.memberId
      this.dataForm.businessId = id
      let rewardPoint = row.rewardPoint
      console.log(rewardPoint)
      if (rewardPoint != undefined) {
        // alert(1)
        this.dataForm.rewardPoint = rewardPoint
      } else {
        this.dataForm.rewardPoint = 0
      }
      this.visible = true
    },
    closeForm () {
      this.visible = false
    }
  }
}
</script>
<style >
/* .fromlist{
  position: relative;
  height: 200px;
} */
.ewjfll .el-form-item__content {
  margin-left: 0 !important;
}
.ewjfll .font_later {
  padding-left: 0 !important;
}
.chose {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding-top: 50px;
  padding-left: 25%; */
}
</style>
